import { Modal } from "antd";

export default function LocationTile({ name, address, price, highestBid, isAuction }) {
    const askingLabel = typeof price === "number" ? `$${price.toLocaleString()}` : "—";
    const bidLabel = typeof highestBid === "number" ? `$${highestBid.toLocaleString()}` : "—";
    const handleLocationInfo = () => {
        Modal.info({
            title: `${name} info`,
            content: (
                <div>
                    <p>Average daily visits: 100</p>
                    <p>Average transaction amount: $150</p>
                </div>
            ),
            okText: "Close",
        });
    };

    return (
        <article className="marketplace-tile">
            <div className="marketplace-tile-header">
                <h4 className="marketplace-tile-title">{name}</h4>
                <p className="marketplace-tile-address">{address}</p>
            </div>
            <div className="marketplace-tile-meta">
                <div>
                    <p className="marketplace-tile-label">Asking Price</p>
                    <p className="marketplace-tile-value">{askingLabel}</p>
                </div>
                <div>
                    <p className="marketplace-tile-label">Highest Bid</p>
                    <p className="marketplace-tile-value">{bidLabel}</p>
                </div>
            </div>
            <div className="marketplace-tile-actions">
                <button className="btn btn-primary">
                    {isAuction ? "Place Bid" : "Buy"}
                </button>
                <button className="btn btn-secondary" onClick={handleLocationInfo}>
                    Location Info
                </button>
            </div>
        </article>
    );
}
